import { BasketProvider } from './state/BasketContext'
import { LanguageProvider, useTranslation } from './i18n/LanguageContext'
import { BasketView } from './components/BasketView'
import { SuggestionsView } from './components/SuggestionsView'
import { IndicatorsView } from './components/IndicatorsView'
import { GlobalActions } from './components/GlobalActions'
import { ProfileEditor } from './components/ProfileEditor'
import { LanguageToggle } from './components/LanguageToggle'
import './app.css'

function AppShell() {
  const { t } = useTranslation()

  return (
    <div className="d-flex flex-column vh-100">
      <header className="bg-light border-bottom px-3 py-2 flex-shrink-0">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="h4 mb-0 text-primary">
            <i className="bi bi-calculator me-2"></i>
            KajChi -
            <span className="text-muted fst-italic fw-normal ms-2">{t('app.tagline')}</span>
            <span className="text-muted fw-normal ms-2">-</span>
            <a href="https://github.com/zoltanpetrik/kajchi" target="_blank" rel="noopener noreferrer" className="ms-2 text-muted" title="GitHub"><i className="bi bi-github"></i></a>
            <LanguageToggle />
          </h1>
          <span className="text-danger small d-none d-lg-inline">{t('app.disclaimer')}</span>
          <div className="d-none d-lg-flex"><GlobalActions /></div>
        </div>
        <ProfileEditor />
      </header>

      <div className="flex-grow-1 d-none d-lg-flex kajchi-main" style={{ minHeight: 0 }}>
        <div className="d-flex flex-column border-end kajchi-left">
          <div className="border-bottom p-3 overflow-auto" style={{ height: '40%' }}>
            <BasketView />
          </div>
          <div className="p-3 overflow-auto" style={{ height: '60%' }}>
            <SuggestionsView />
          </div>
        </div>

        <div className="p-3 overflow-auto kajchi-right">
          <IndicatorsView />
        </div>
      </div>

      <div className="flex-grow-1 d-lg-none d-flex align-items-center justify-content-center p-4">
        <div className="text-center text-muted">
          <i className="bi bi-display display-1 d-block mb-3"></i>
          <p>{t('app.mobileBanner')}</p>
        </div>
      </div>
    </div>
  )
}

function App() {
  return (
    <LanguageProvider>
      <BasketProvider>
        <AppShell />
      </BasketProvider>
    </LanguageProvider>
  )
}

export default App
